import * as React from 'react';
import b_ from 'b_';

interface Props {
  title: string;
}

const b = b_.with('invest-landing-subitem');

export const SubItem: React.FC<Props> = ({ title, children }) => (
  <div className={b()}>
    <div className={b('wrapper')}>
      <div>
        <h3 className={b('title')}>{title}</h3>
        <p className={b('text')}>{children}</p>
      </div>
    </div>
  </div>
);

export default SubItem;
